import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ComponentDataService }                 from '../_services/component-data.service';

@Component({
               selector      : 'app-home',
               templateUrl   : './home.component.html',
               styleUrls     : [ './home.component.scss' ],
               encapsulation : ViewEncapsulation.None
    
           })
export class HomeComponent implements OnInit {
    
    // private title: string = 'CapChaos - Software & Tactical Management Service';
    // private description: string = 'Implementing your strategy by converting high-level objectives into low-level tactical decision making, using cutting edge technology and years of hands-on experience in management methodology.';
    // private imageURL: string = 'assets/images/mainbg.webp';
    
    constructor(public dataExchange: ComponentDataService) { }
    
    ngOnInit(): void {
        // this.dataExchange.setBowserTags(this.title, this.description, this.imageURL);
    }
    
    scroll(el: HTMLElement) {
        el.scrollIntoView();
    }
    
}
